{
    "CommonAdminAllTelServer": "[Alle telefonieservers].",
    "CommonAdminAnyPartition": "[Elke Partitie]",
    "CommonAdminAnyDevices": "[Elk apparaat]",
    "CommonAdminAnyAgents": "[Elke ACD Agent].",
    "CommonAdminAnyAgentForDevice": "[Any At Set Device].",
    "CommonAdminAnyDeviceForAgent": "[Any With Set ACD Agent].",
    "CommonAdminUnknownOrDeleted": "[Onbekend of Verwijderd]",
    "NAME": "CommonAdmin"
}